import styled from "styled-components"

import {Card} from "@irati/ui/src/Layout"

export const CustomPaddingCard = styled(Card)`
  padding: ${({theme}) => `${theme.spacing.four} ${theme.spacing.four} ${theme.spacing.four} 0`};
`
